import React from 'react';
import { Typography } from '@mui/material';
import { useTaskStatusLabelStyles } from './styles';
import { TaskStatusLabelProps } from './types';

const TaskStatusLabel = ({ label, status }: TaskStatusLabelProps) => {
  const classes = useTaskStatusLabelStyles();

  return <Typography className={`${classes.root} ${classes[status]}`}>{label}</Typography>;
};
export default TaskStatusLabel;
